import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { HelpersService } from '../../../../core/services/helpers.service';
import { OperationsService } from '../../../../core/services/operations.service';
import { ParcellaStragiudizialeForm } from '../../../form/parcelle/stragiudiziali/parcella-stragiudiziale-form';
import { SezioneParcelleStragiudizialiResponse } from '../../../models/dto/sezione-parcelle-stragiudiziali-response';
import { ParcellaStragiudiziale } from '../../../models/parcella-stragiudiziale';
import { SezioneParcelleStragiudiziali } from '../../../models/sezioni/sezione-parcelle-stragiudiziali';

@Component({
    selector: 'div [parcella-stragiudiziale-form-add]',
  templateUrl: '../../../form/parcelle/stragiudiziali/parcella-stragiudiziale-form.html'
})

export class ParcelleStragiudizialiAddComponent extends ParcellaStragiudizialeForm {
  idSezione: string;
  urlInsert: string;
  urlReadSezioneLegali: string;
  urlReadSezioneEconomica: string;
  urlGetScaglioni: string;
  tipoFascicolo: any;
  tipoPratica: any;
  idFascicolo: string;

  @Output() onReturn: EventEmitter<SezioneParcelleStragiudiziali> = new EventEmitter<SezioneParcelleStragiudiziali>();

  constructor(@Inject(OperationsService) operationService, @Inject(FormBuilder) campiForm, @Inject(HelpersService) helpers: HelpersService) {
        super(operationService, campiForm, helpers);
  }

  ngOnInit() {
    this.setTitle('Aggiungi Parcella');
    this.isInserimento(true);
  }

  getParcellaStragiudiziale() {
    return new ParcellaStragiudiziale();
  }

  getUrlReadSezioneLegali() {
    return this.urlReadSezioneLegali;
  }

  getUrlReadSezioneEconomica() {
    return this.urlReadSezioneEconomica;
  }

  getTipoFascicolo(): any {
    return this.tipoFascicolo;
  }

  getTipoPratica(): any {
    return this.tipoPratica;
  }

  getIdFascicolo() {
    return this.idFascicolo;
  }

  getUrlGetScaglioni() {
    return this.urlGetScaglioni;
  }

  getRequest(request: ParcellaStragiudiziale) {
    this.operationService.addParcellaStragiudiziale(this.urlInsert, request, this.idSezione , this.idFascicolo).subscribe((response: any) => this.datiParcellaStragiudiziale(response));
  }

  datiParcellaStragiudiziale(response: SezioneParcelleStragiudizialiResponse) {
    if (response.returnCode === 'OK') {
      this.onReturn.emit(response.sezione);
    }
  }

  inizializza(idSezione: string,
              idFascicolo: string,
              idSezioneLegali: string,
              idSezioneEconomica: string,
              urlInsert: string,
              urlReadSezioneLegali: string,
              urlReadSezioneEconomica: string,
              urlGetScaglioni: string,
              tipoFascicolo: any,
              tipoPratica: number) {
    this.idSezione = idSezione;
    this.idFascicolo = idFascicolo;
    this.urlInsert = urlInsert;
    this.urlReadSezioneLegali = urlReadSezioneLegali;
    this.urlReadSezioneEconomica = urlReadSezioneEconomica;
    this.urlGetScaglioni = urlGetScaglioni;
    this.tipoFascicolo = tipoFascicolo;
    this.tipoPratica = tipoPratica;
    this.createForm();
    this.populateSelect();
    if (idSezioneLegali) {
      this.readSezioneLegali(idSezioneLegali);
    }
    if (idSezioneEconomica) {
      this.readSezioneEconomica(idSezioneEconomica);
    }
  }

}
